import { Component, OnInit } from '@angular/core';
import { AuthService } from '../shared/services/auth/auth.service';
import { ReadConfigService } from '../shared/services/common/read-config.service';
import { GridDataResult } from '@progress/kendo-angular-grid';

@Component({
  selector: 'app-help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.css']
})
export class HelpComponent implements OnInit {
  videoGridView: GridDataResult;
  docGridView: GridDataResult;
  helpDeskPhone: any;
  businessHoursMsg: any;

  constructor(
    private authService: AuthService,
    private readConfigService: ReadConfigService) { }

  ngOnInit() {
    if (this.authService.isLoggedIn) {
      this.authService.loggedInChecker(this.authService.isLoggedIn);
    }
    const config = this.readConfigService.getHelpText();
    this.videoGridView = config.HelpVideoContant;
    this.docGridView = config.HelpDocContant;
    this.helpDeskPhone = config.HelpDeskPhone;
    this.businessHoursMsg = config.BusinessHoursMsg;
  }
}
